import { createSelector } from 'reselect';
import SCOPE from './types';

const selector = state => state[SCOPE];

export const breadcrumbSelector = createSelector(
  selector,
  (state) => state.drilldown
);

export default selector;
